import resolveConfig from "tailwindcss/resolveConfig";

// @ts-ignore
import tailwindConfig from "@moment/tailwind-config";

export const config = resolveConfig(tailwindConfig);
